<!--
 * @Description: 部门多条查找带回
 * @Author: PF
 * @Date: 2023-02-03 15:00:22
 * @LastEditors: PF
 * @LastEditTime: 2024-10-08 11:09:50
-->
<template>
  <div class="cha-zhao-duo-tiao">
    <el-dialog style="min-width: 770px;" class="wp70 hp70" :model-value="openDuoTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">部门</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDuoTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>

      <div class="list-page pl0 pt0 pr0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
              <el-form-item>
                <el-select placeholder="校区" v-model="dataGrid.parms.lsxqid" clearable filterable @change="bindTable()">
                  <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
          </el-header>
          <el-main>

            <el-table :data="tableData" style="width: 100%" row-key="id" default-expand-all v-loading="dataGrid.loading" @selection-change="dataGrid.selectionChange" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" height="100%" border stripe lazy>
              <el-table-column fixed type="selection" :selectable="selectable" align="center" width="55" />
              <el-table-column fixed type="index" label="序号" align="center" width="80" />
              <el-table-column min-width="150" align="left" header-align="center" label="机构名称" show-overflow-tooltip>
                <template #default="scope">
                  {{scope.row.jgmc}}
                </template>
              </el-table-column>
              <el-table-column prop="jgh" label="机构号" align="center" show-overflow-tooltip />
              <el-table-column label="机构标识" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span v-if="scope.row.jgbs === 1">系部/专业部</span>
                  <span v-if="scope.row.jgbs === 2">教研组</span>
                  <span v-if="scope.row.jgbs === 99">其他机构</span>
                </template>
              </el-table-column>
              <el-table-column prop="lsxqmc" label="隶属校区" align="center" show-overflow-tooltip />
              <el-table-column prop="xm" label="负责人" align="center" show-overflow-tooltip />
            </el-table>
          </el-main>
        </el-container>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="savestudent()">选择</el-button>
            <el-button type="info" @click="closeWindow('openDuoTiao', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadList, closeWindow } from '@/api/common.js'
import { loadXiaoQuSelect } from '@/api/queryXiaoQu.js'

const props = defineProps({
  openDuoTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDuoTiao', 'ReturnData'])

// 加载 校区 下拉框
const xqData = ref()
// 内容区域 开始
const tableData = ref() // 内容列表

const dataGrid = ref({
  parms: {},
  data: [],
  loading: false,
  orderBy: { prop: 'jgh', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    initLeftList()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection
  }
})
const bindTable = async () => {
  loadList({
    url: '/api/v2/xiaoneijigou/tree',
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
      tableData.value = res.data
    }
  })
}
const savestudent = () => {
  emits('ReturnData', dataGrid.value.multipleSelection)
  closeWindow('openDuoTiao', emits, false)
}

// 禁止选择
const selectable = (item) => {
  return !(ids.value.indexOf(item.id) >= 0)
}
const ids = ref([])
watch(
  () => props.openDuoTiao,
  () => {
    if (props.openDuoTiao) {
      ids.value = props.row.ids || []
      loadXiaoQuSelect(xqData)
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>
